export {
  OnboardingCompletedDialog,
  OnboardingCompletedDialogProps,
} from './OnboardingCompletedDialog';
